import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:w-1/2 mx-auto p-10 pp" }
const _hoisted_2 = ["innerHTML"]

import apiUseCase from '@/usecase/apiUseCase'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'privacy-policy',
  setup(__props) {

const endpoint = 'settings/v1/GlobalSetting'
const dataSource = ref(null) as any

const getData = () => {
  apiUseCase.get(endpoint).then((response) => {
    const {
      error,
      result
    } = response
    if (!error) {
      dataSource.value = result.filter((x: any) => x.Code === 'KP')[0].Value
    }
  })
}

onMounted(() => {
  getData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { innerHTML: _unref(dataSource) }, null, 8, _hoisted_2)
  ]))
}
}

})